var _defs, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _polygon, _polygon2, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _circle, _path15, _path16, _path17, _g, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _path25, _rect62, _rect63, _path26, _path27, _rect64, _circle2, _circle3, _circle4, _line, _line2, _rect65, _g2, _rect66, _rect67, _circle5, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawSvg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "95c6c890-4df0-4047-9b20-53c1698e0703",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1139.67,
    height: 810.43,
    viewBox: "0 0 1139.67 810.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "27534bda-5ea1-4910-bcb7-b6f2fadd52ae",
    x1: 685.66,
    y1: 732.28,
    x2: 685.66,
    y2: 530.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "freelancer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 509,
    cy: 689.93,
    rx: 509,
    ry: 120.5,
    fill: "#3287ca",
    opacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.69,406.21S202.1,453.62,175.34,524s45.88,187.34,45.88,187.34-.78-.11-2.22-.37C121.63,693.76,73.24,582.4,127.39,499.66,147.52,468.9,164,432.82,154.69,406.21Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#3287ca"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.69,406.21s26.76,58.11,0,105.52S150.1,692.2,221.22,711.32",
    transform: "translate(-30.16 -44.79)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.25,598s54.1-8.62,59,39.87,104,55.2,104,55.2-.65.44-1.86,1.24C149.63,748,71.41,728.49,83.2,657.17,87.58,630.65,87.23,604,70.25,598Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#3287ca"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.25,598s54.1-8.62,59,39.87,104,55.2,104,55.2-.65.44-1.86,1.24C149.63,748,71.41,728.49,83.2,657.17,87.58,630.65,87.23,604,70.25,598Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#f5f5f5",
    opacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.25,598s42,9.22,38.54,47.4,62.36,84,124.51,47.67",
    transform: "translate(-30.16 -44.79)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.59,405.63c-6.95,34.06-42.63,51.14-62.62,76.55-37.67,47.89-23,117.84.9,173.86,8,18.76,17.08,38.61,13.69,58.72-4.13,24.6-26.08,42.58-49.13,52.12-42,17.37-92.3,13.23-130.91-10.79-33.36-20.75-57.26-54.51-91.19-74.32-56.79-33.15-129.07-20.63-190.74,2.21-43.62,16.15-91.32,37.17-134.67,20.28-30.5-11.88-51.59-40.8-63.08-71.45-5.54-14.8-9.57-30.82-20.16-42.55-6.3-7-14.52-11.93-22.93-16.1-76.88-38.12-174-17.7-248.63-60-50.42-28.55-82.71-82.4-97-138.56s-12.63-115-9-172.88c2.58-41.1,7.21-85,33.47-116.7C124.37,52.49,172,40,215.14,46.39s82.15,29.11,116.52,55.88c43,33.47,82.78,75.13,135.51,88.69,35.91,9.23,73.68,4.18,110.72,2.43,61.92-2.92,123.86,3.58,185.43,10.7,30,3.47,60.1,7.11,89.84,12.39q10,1.77,20,3.81,5,1,10,2.14c2.6.57,5.19,1.17,7.78,1.78q6.13,1.44,12.22,3c11.66,3,23.21,6.45,34.64,10.35,39.74,13.57,71.6,38.2,109.13,55.41,24.46,11.22,51.13,14.32,74.29,28.6C1149.75,339.19,1175.9,369.81,1168.59,405.63Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#3287ca",
    opacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M636.3,688.77s41.1-3.26,52.93,10.88,54.06,46.56,36.63,53.78-111-21.61-111-21.61Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#ffb9b9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M467.33,196.56a21.43,21.43,0,0,0-17.48-19.49c-6.26-1-13.25.77-18.63-2.6-2.43-1.53-4.17-3.92-6.13-6-7.68-8.21-19.21-12-30.45-12.33s-22.32,2.39-33.12,5.5c-21.56,6.21-44.34,15.32-55.81,34.6-17.44,29.35-1.35,68.91-15.14,100.14-6,13.64-17.44,24.78-21.16,39.22-5,19.29,4.86,38.86,12.45,57.28a273.18,273.18,0,0,1,15.44,51.2c3.05,15.48,4.75,31.57,1.31,47-1.51,6.75-4,13.62-2.66,20.4,2,10.26,11.92,16.73,20.94,22l2.35,1.38c13,7.6,26.37,15.36,41.26,17.24,9.25,1.16,19-.12,27-4.85s14.09-13.17,14.77-22.46c.76-10.51-5.09-20.35-6.35-30.82a9.37,9.37,0,0,1,.35-4.72c.83-2,2.76-3.29,4.54-4.53,25.64-17.88,39.39-51.34,33.72-82.08-3.86-20.94-15.86-41.76-10.05-62.25,3.21-11.32,11.48-20.49,16.12-31.3a52.54,52.54,0,0,0,1.72-36.42c-2.65-8.26-7.45-16.51-5.8-25,2.91-15.08,23-19.89,30.59-33.25,5.63-9.94,2.3-24-7.2-30.32",
    transform: "translate(-30.16 -44.79)",
    fill: "#b96b6b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M467.33,196.56a21.43,21.43,0,0,0-17.48-19.49c-6.26-1-13.25.77-18.63-2.6-2.43-1.53-4.17-3.92-6.13-6-7.68-8.21-19.21-12-30.45-12.33s-22.32,2.39-33.12,5.5c-21.56,6.21-44.34,15.32-55.81,34.6-17.44,29.35-1.35,68.91-15.14,100.14-6,13.64-17.44,24.78-21.16,39.22-5,19.29,4.86,38.86,12.45,57.28a273.18,273.18,0,0,1,15.44,51.2c3.05,15.48,4.75,31.57,1.31,47-1.51,6.75-4,13.62-2.66,20.4,2,10.26,11.92,16.73,20.94,22l2.35,1.38c13,7.6,26.37,15.36,41.26,17.24,9.25,1.16,19-.12,27-4.85s14.09-13.17,14.77-22.46c.76-10.51-5.09-20.35-6.35-30.82a9.37,9.37,0,0,1,.35-4.72c.83-2,2.76-3.29,4.54-4.53,25.64-17.88,39.39-51.34,33.72-82.08-3.86-20.94-15.86-41.76-10.05-62.25,3.21-11.32,11.48-20.49,16.12-31.3a52.54,52.54,0,0,0,1.72-36.42c-2.65-8.26-7.45-16.51-5.8-25,2.91-15.08,23-19.89,30.59-33.25,5.63-9.94,2.3-24-7.2-30.32",
    transform: "translate(-30.16 -44.79)",
    opacity: 0.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "478.5 675.93 263.5 675.93 263.5 560.93 383.5 606.93 478.5 560.93 478.5 675.93",
    fill: "#777b9b"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "478.5 675.93 263.5 675.93 263.5 560.93 383.5 606.93 478.5 560.93 478.5 675.93",
    opacity: 0.1
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M482.66,731.77s-39,9.32-43,26.4,23,15.53,23,15.53,38-7.77,43-38.83S482.66,731.77,482.66,731.77Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#ffb9b9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M482.66,731.77s-39,9.32-43,26.4,23,15.53,23,15.53,38-7.77,43-38.83S482.66,731.77,482.66,731.77Z",
    transform: "translate(-30.16 -44.79)",
    opacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M377.93,783.83s-36.77,2.39-37.27,32.22c-.07,4,38.3,5.16,83.85-19.33s48.65-27.07,48.65-27.07-17.6-28.36-30-32.22S377.93,783.83,377.93,783.83Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#cbcdda"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M162.66,669.71s-42,35,36,84,153,40,153,40,81.36-9.63,93.68-47.82-60.68-70.18-60.68-70.18-80,0-116-23S162.66,669.71,162.66,669.71Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#777b9b"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M389.66,609.71s36,21,85,0c37.7-16.16,120.4-9.82,156.53-6,16.94,1.77,31.45,13.44,36.08,29.83,3.78,13.37,1,29.8-21.62,45.2-50,34-85,44-98,58s-50,21-50,21-47-7-47-17,43-59,43-59-63,58-128-20S389.66,609.71,389.66,609.71Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#777b9b"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M371.66,468.71l-127-87s60.92-41.31,66.15-78.23a30,30,0,0,0-4.15-20.77c-25-40,88,0,88,0a236.25,236.25,0,0,0,4.25,31c4.91,24.35,15.27,56.78,36.75,73C472.66,414.71,371.66,468.71,371.66,468.71Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#ffb9b9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M398.91,313.67a74.06,74.06,0,0,1-88.1-10.19,30,30,0,0,0-4.15-20.77c-25-40,88,0,88,0A236.25,236.25,0,0,0,398.91,313.67Z",
    transform: "translate(-30.16 -44.79)",
    opacity: 0.1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 331.5,
    cy: 202.93,
    r: 74,
    fill: "#ffb9b9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M407.66,345.71s-15,88-40,83-103-93-103-93-81,27-68,93,26,122-1,143-44,119-44,119,86-36,131-22,91,7,102-6,27-41,27-41-23-34-12-51,25-18,33-66,71-65,59-92S456.66,345.71,407.66,345.71Z",
    transform: "translate(-30.16 -44.79)",
    opacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M407.66,341.71s-15,88-40,83-103-93-103-93-81,27-68,93,26,122-1,143-44,119-44,119,86-36,131-22,91,7,102-6,27-41,27-41-23-34-12-51,25-18,33-66,71-65,59-92S456.66,341.71,407.66,341.71Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#cbcdda"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M467.66,702.71s40-10,54,2,61,37,45,47-113-3-113-3Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#ffb9b9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.66,424.71a10.68,10.68,0,0,0,6.87-1c-27.78-10.72-99.87-92-99.87-92s-2.84.95-7.38,2.92C271.06,349.94,335.39,420.26,357.66,424.71Z",
    transform: "translate(-30.16 -44.79)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.66,408.71c27.58-10.61-51,44-59,92s-22,49-33,66,12,51,12,51-16,28-27,41c-6.3,7.45-24.09,12.91-46.59,13.6,27.14.86,49.38-5.09,56.59-13.6,11-13,27-41,27-41s-23-34-12-51,25-18,33-66S475.16,411.21,481.66,408.71Z",
    transform: "translate(-30.16 -44.79)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.43,682.54c-.51,2.67-.77,4.18-.77,4.18s55.92-23.41,101.18-25.13C217.91,660.14,172.77,675,152.43,682.54Z",
    transform: "translate(-30.16 -44.79)"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M484.66,403.71s9,1,18,48,44,92,44,92a217.87,217.87,0,0,1,32,61c12,36,65.5,83.5,84.5,85.5,0,0-36.5,36.5-32.5,46.5s-4,0-4,0-50-19-61-50-59-81-59-81-64-124-67-144S484.66,403.71,484.66,403.71Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#cbcdda"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M209.16,572.21s77,9,94,33,95.75-13.94,95.75-13.94",
    transform: "translate(-30.16 -44.79)",
    opacity: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M284.66,435.71s33,121,45,136,105,138,149,130c0,0-13,56-22,58,0,0-91-90-122-89,0,0-57-47-63-70s-54-98-54-98-24-53-14-76S266.66,413.71,284.66,435.71Z",
    transform: "translate(-30.16 -44.79)",
    opacity: 0.1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M285.66,433.71s33,121,45,136,105,138,149,130c0,0-13,56-22,58,0,0-91-90-122-89,0,0-57-47-63-70s-54-98-54-98-24-53-14-76S267.66,411.71,285.66,433.71Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#cbcdda"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M415.33,177.56a21.43,21.43,0,0,0-17.48-19.49c-6.26-1-13.25.77-18.63-2.6-2.43-1.53-4.17-3.92-6.13-6-7.68-8.21-19.21-12-30.45-12.33s-22.32,2.39-33.12,5.5c-21.56,6.21-44.34,15.32-55.81,34.6-17.44,29.35-1.35,68.91-15.14,100.14-6,13.64-17.44,24.78-21.16,39.22-5,19.29,4.86,38.86,12.45,57.28a273.18,273.18,0,0,1,15.44,51.2c3.05,15.48,4.75,31.57,1.31,47-1.51,6.75-4,13.62-2.66,20.4,2,10.26,11.92,16.73,20.94,22l2.35,1.38c13,7.6,26.37,15.36,41.26,17.24,9.25,1.16,19-.12,27-4.85s14.09-13.17,14.77-22.46c.76-10.51-5.09-20.35-6.35-30.82a9.37,9.37,0,0,1,.35-4.72c.83-2,2.76-3.29,4.54-4.53,25.64-17.88,39.39-51.34,33.72-82.08-3.86-20.94-15.86-41.76-10.05-62.25,3.21-11.32,11.48-20.49,16.12-31.3a52.54,52.54,0,0,0,1.72-36.42c-2.65-8.26-7.45-16.51-5.8-25,2.91-15.08,23-19.89,30.59-33.25,5.63-9.94,2.3-24-7.2-30.32",
    transform: "translate(-30.16 -44.79)",
    opacity: 0.1
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M413.33,176.56a21.43,21.43,0,0,0-17.48-19.49c-6.26-1-13.25.77-18.63-2.6-2.43-1.53-4.17-3.92-6.13-6-7.68-8.21-19.21-12-30.45-12.33s-22.32,2.39-33.12,5.5c-21.56,6.21-44.34,15.32-55.81,34.6-17.44,29.35-1.35,68.91-15.14,100.14-6,13.64-17.44,24.78-21.16,39.22-5,19.29,4.86,38.86,12.45,57.28a273.18,273.18,0,0,1,15.44,51.2c3.05,15.48,4.75,31.57,1.31,47-1.51,6.75-4,13.62-2.66,20.4,2,10.26,11.92,16.73,20.94,22l2.35,1.38c13,7.6,26.37,15.36,41.26,17.24,9.25,1.16,19-.12,27-4.85s14.09-13.17,14.77-22.46c.76-10.51-5.09-20.35-6.35-30.82a9.37,9.37,0,0,1,.35-4.72c.83-2,2.76-3.29,4.54-4.53,25.64-17.88,39.39-51.34,33.72-82.08-3.86-20.94-15.86-41.76-10.05-62.25,3.21-11.32,11.48-20.49,16.12-31.3a52.54,52.54,0,0,0,1.72-36.42c-2.65-8.26-7.45-16.51-5.8-25,2.91-15.08,23-19.89,30.59-33.25,5.63-9.94,2.3-24-7.2-30.32",
    transform: "translate(-30.16 -44.79)",
    fill: "#b96b6b"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M481.36,812a11.67,11.67,0,0,0,3.83-5.78c.5-2.3-.48-5.05-2.68-5.89-2.46-.94-5.09.76-7.08,2.49s-4.28,3.69-6.89,3.32a10.48,10.48,0,0,0,3.24-9.81,4.1,4.1,0,0,0-.9-2c-1.37-1.46-3.84-.83-5.48.32-5.2,3.66-6.65,10.72-6.68,17.08-.52-2.29-.08-4.68-.1-7s-.66-5-2.64-6.22a8,8,0,0,0-4-.95c-2.34-.09-4.94.15-6.54,1.86-2,2.12-1.47,5.69.26,8s4.35,3.8,6.77,5.42a15,15,0,0,1,4.84,4.61,4.57,4.57,0,0,1,.36.82H472.3A40.83,40.83,0,0,0,481.36,812Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#3287ca"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 585,
    y: 227.43,
    width: 318,
    height: 22,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 585,
    y: 322.43,
    width: 318,
    height: 22,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 585,
    y: 421.43,
    width: 318,
    height: 22,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 613,
    y: 170.43,
    width: 20,
    height: 57,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 613,
    y: 179.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 613,
    y: 210.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 643,
    y: 170.43,
    width: 20,
    height: 57,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 643,
    y: 179.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 643,
    y: 210.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 673,
    y: 170.43,
    width: 20,
    height: 57,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 673,
    y: 179.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 673,
    y: 210.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 703,
    y: 170.43,
    width: 20,
    height: 57,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 703,
    y: 179.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 703,
    y: 210.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 733,
    y: 170.43,
    width: 20,
    height: 57,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 733,
    y: 179.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 733,
    y: 210.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 763,
    y: 170.43,
    width: 20,
    height: 57,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 763,
    y: 179.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 763,
    y: 210.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 793,
    y: 170.43,
    width: 20,
    height: 57,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 793,
    y: 179.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 793,
    y: 210.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 825.16,
    y: 409.21,
    width: 20,
    height: 57,
    transform: "translate(-137.76 375.95) rotate(-26.63)",
    fill: "#3287ca",
    opacity: 0.1
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 817.32,
    y: 420.07,
    width: 20,
    height: 4,
    transform: "translate(-131.58 370.77) rotate(-26.63)",
    fill: "#3287ca",
    opacity: 0.1
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 831.21,
    y: 447.78,
    width: 20,
    height: 4,
    transform: "translate(-142.53 379.94) rotate(-26.63)",
    fill: "#3287ca",
    opacity: 0.1
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 613,
    y: 266.43,
    width: 20,
    height: 57,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 613,
    y: 275.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 613,
    y: 306.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 643,
    y: 266.43,
    width: 20,
    height: 57,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 643,
    y: 275.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 643,
    y: 306.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 673,
    y: 266.43,
    width: 20,
    height: 57,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 673,
    y: 275.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 673,
    y: 306.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 798,
    y: 266.43,
    width: 20,
    height: 57,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 798,
    y: 275.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 798,
    y: 306.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 828,
    y: 266.43,
    width: 20,
    height: 57,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 828,
    y: 275.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 828,
    y: 306.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 858,
    y: 266.43,
    width: 20,
    height: 57,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 858,
    y: 275.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 858,
    y: 306.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 613,
    y: 364.43,
    width: 20,
    height: 57,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 613,
    y: 373.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 613,
    y: 404.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 643,
    y: 364.43,
    width: 20,
    height: 57,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 643,
    y: 373.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 643,
    y: 404.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 673,
    y: 364.43,
    width: 20,
    height: 57,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 673,
    y: 373.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 673,
    y: 404.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 703,
    y: 364.43,
    width: 20,
    height: 57,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 703,
    y: 373.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 703,
    y: 404.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 733,
    y: 364.43,
    width: 20,
    height: 57,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 733,
    y: 373.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 733,
    y: 404.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 763,
    y: 364.43,
    width: 20,
    height: 57,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 763,
    y: 373.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 763,
    y: 404.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M873.16,220.29v51.92h-20V216.48Q863.2,218.25,873.16,220.29Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#3287ca",
    opacity: 0.1
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 823,
    y: 179.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 823,
    y: 210.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M903.16,227.23v45h-20V222.43c2.6.57,5.19,1.17,7.78,1.78Q897.08,225.65,903.16,227.23Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#3287ca",
    opacity: 0.1
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M903.16,227.23v1h-20v-4h7.78Q897.08,225.65,903.16,227.23Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#3287ca",
    opacity: 0.1
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 853,
    y: 210.43,
    width: 20,
    height: 4,
    fill: "#3287ca",
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.7,
    cy: 161.75,
    r: 37.33,
    fill: "#3287ca",
    opacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.7,
    cy: 161.75,
    r: 31.68,
    fill: "#3287ca",
    opacity: 0.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.7,
    cy: 161.75,
    r: 2.26,
    fill: "#3287ca",
    opacity: 0.1
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 160.28,
    y1: 138,
    x2: 147.82,
    y2: 159.8,
    fill: "none",
    stroke: "#3287ca",
    strokeMiterlimit: 10,
    opacity: 0.1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 160.84,
    y1: 169.11,
    x2: 148.74,
    y2: 162.74,
    fill: "none",
    stroke: "#3287ca",
    strokeMiterlimit: 10,
    opacity: 0.1
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 468.26,
    y: 715.48,
    width: 117.43,
    height: 16.59,
    rx: 6.5,
    ry: 6.5,
    fill: "#535461"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    x: 539.73,
    y: 530.49,
    width: 291.85,
    height: 201.8,
    rx: 28.22,
    ry: 28.22,
    fill: "url(#27534bda-5ea1-4910-bcb7-b6f2fadd52ae)"
  }))), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 544.94,
    y: 534.21,
    width: 276.47,
    height: 198.07,
    rx: 26.84,
    ry: 26.84,
    fill: "#3e3f49"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 548.77,
    y: 534.21,
    width: 276.47,
    height: 198.07,
    rx: 26.84,
    ry: 26.84,
    fill: "#535461"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 699.92,
    cy: 631.88,
    r: 8.93,
    fill: "#e0e0e0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M252.72,765.12s-15.88-5.38-23.52,8.61a25.52,25.52,0,0,0,.34,24.57c5,9.07,15.36,20.85,35,19.8,16.62-.89,22.15-13.57,23.65-25.37a26.06,26.06,0,0,0-34.61-27.9Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#3287ca"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M232.9,799.56a25.52,25.52,0,0,1-.34-24.57c7.64-14,23.52-8.61,23.52-8.61l.81-.29a25.83,25.83,0,0,1,18.66.42,25.84,25.84,0,0,0-22-2.1l-.81.29s-15.88-5.38-23.52,8.61a25.52,25.52,0,0,0,.34,24.57c3.31,6,8.92,13.11,18,17A39.35,39.35,0,0,1,232.9,799.56Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#fff",
    opacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M244.52,771.85s5.89,4.63,20.18,0",
    transform: "translate(-30.16 -44.79)",
    opacity: 0.2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M243.26,738.21s10.09,27.33,9.25,34.48l8-.84s-13.46-24-10.09-33.64Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#3287ca"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M243.26,738.21s10.09,27.33,9.25,34.48l8-.84s-13.46-24-10.09-33.64Z",
    transform: "translate(-30.16 -44.79)",
    opacity: 0.2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M284.45,740.5s-15.88-8.12-23-1.41-8.2,23.86-8.2,23.86S279.16,766.51,284.45,740.5Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#3287ca"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M284.45,740.5s-15.88-8.12-23-1.41-8.2,23.86-8.2,23.86S279.16,766.51,284.45,740.5Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#fff",
    opacity: 0.1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M253.26,762.95s4.17-19.91,31.19-22.45",
    transform: "translate(-30.16 -44.79)",
    fill: "none",
    stroke: "#3287ca",
    strokeMiterlimit: 10
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M763.55,347.49s-6.06-2.06-9,3.29a9.75,9.75,0,0,0,.13,9.38c1.92,3.46,5.87,8,13.35,7.56,6.35-.34,8.46-5.18,9-9.69a10,10,0,0,0-13.22-10.66Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#3287ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756,360.65a9.75,9.75,0,0,1-.13-9.38c2.92-5.34,9-3.29,9-3.29l.31-.11a9.87,9.87,0,0,1,7.13.16,9.87,9.87,0,0,0-8.41-.8l-.31.11s-6.06-2.06-9,3.29a9.75,9.75,0,0,0,.13,9.38,14.57,14.57,0,0,0,6.86,6.49A15,15,0,0,1,756,360.65Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#3287ca",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.42,350.06s2.25,1.77,7.71,0",
    transform: "translate(-30.16 -44.79)",
    fill: "#3287ca",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.93,337.21s3.85,10.44,3.53,13.17l3.05-.32s-5.14-9.15-3.85-12.85Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#3287ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.93,337.21s3.85,10.44,3.53,13.17l3.05-.32s-5.14-9.15-3.85-12.85Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#3287ca",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.67,338.09s-6.07-3.1-8.78-.54-3.13,9.11-3.13,9.11S773.65,348,775.67,338.09Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#3287ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.67,338.09s-6.07-3.1-8.78-.54-3.13,9.11-3.13,9.11S773.65,348,775.67,338.09Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#3287ca",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.75,346.66s1.59-7.6,11.91-8.58",
    transform: "translate(-30.16 -44.79)",
    fill: "#3287ca"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M891.55,446.49s-6.06-2.06-9,3.29a9.75,9.75,0,0,0,.13,9.38c1.92,3.46,5.87,8,13.35,7.56,6.35-.34,8.46-5.18,9-9.69a10,10,0,0,0-13.22-10.66Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#3287ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884,459.65a9.75,9.75,0,0,1-.13-9.38c2.92-5.34,9-3.29,9-3.29l.31-.11a9.87,9.87,0,0,1,7.13.16,9.87,9.87,0,0,0-8.41-.8l-.31.11s-6.06-2.06-9,3.29a9.75,9.75,0,0,0,.13,9.38,14.57,14.57,0,0,0,6.86,6.49A15,15,0,0,1,884,459.65Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#3287ca",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.42,449.06s2.25,1.77,7.71,0",
    transform: "translate(-30.16 -44.79)",
    fill: "#3287ca",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.93,436.21s3.85,10.44,3.53,13.17l3.05-.32s-5.14-9.15-3.85-12.85Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#3287ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.93,436.21s3.85,10.44,3.53,13.17l3.05-.32s-5.14-9.15-3.85-12.85Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#3287ca",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.67,437.09s-6.07-3.1-8.78-.54-3.13,9.11-3.13,9.11S901.65,447,903.67,437.09Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#3287ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.67,437.09s-6.07-3.1-8.78-.54-3.13,9.11-3.13,9.11S901.65,447,903.67,437.09Z",
    transform: "translate(-30.16 -44.79)",
    fill: "#3287ca",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.75,445.66s1.59-7.6,11.91-8.58",
    transform: "translate(-30.16 -44.79)",
    fill: "#3287ca"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawSvg2);
export default __webpack_public_path__ + "static/media/undraw_svg_2.9c6c3050677e11f43dfbe6c70c6876bd.svg";
export { ForwardRef as ReactComponent };